import { Dismissed, PromoBanners } from '@/PromoBanner/constants';
import { SearchDispatcherEvent } from '~/native/dispatchers/constants';
import sendMessageToNative from '~/native/dispatchers/sendMessageToNative';
import BrowserCookies from '~/utilities/BrowserCookies';

function sendNativeDismissEvent(banner: PromoBanners, dismissed: Dismissed) {
  let BannerNativeEvent: SearchDispatcherEvent;
  switch (banner) {
    case PromoBanners.Earth:
      BannerNativeEvent = SearchDispatcherEvent.DismissEarthDayBanner;
      break;
    case PromoBanners.Ev:
      BannerNativeEvent = SearchDispatcherEvent.DismissEVBanner;
      break;
    case PromoBanners.PriceDrop:
      BannerNativeEvent = SearchDispatcherEvent.DismissPriceDrop;
      break;
  }

  sendMessageToNative(BannerNativeEvent, {
    value: String(dismissed)
  });
}

export function setBannerDismissedCookie(banner: PromoBanners, cookie: string) {
  const fourteenDays = 14 * 24 * 60 * 60 * 1000;
  const expires = new Date(Date.now() + fourteenDays);

  BrowserCookies.set(cookie, String(Dismissed.Banner), {
    expires,
    path: '/'
  });

  sendNativeDismissEvent(banner, Dismissed.Banner);
}

export function getBannerName(
  banner: PromoBanners,
  restrictedState: boolean
): string {
  switch (banner) {
    case PromoBanners.Earth:
      return 'Earth Day';
    case PromoBanners.Ev:
      return 'EV Tax Credit';
    case PromoBanners.PriceDrop:
      return restrictedState ? 'New Price' : 'Price Drop';
  }
}
